var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"navbar"},[_c('div',{staticClass:"navbar-brand"},[_c('img',{staticClass:"my-auto d-block ml-4",attrs:{"src":require("@/assets/img/logo.png"),"height":"32"}})])])
}]

export { render, staticRenderFns }